(function () {
	'use strict';
	$(document).ready(function () {


		if ($('.homepage').length) {

			$('.js-ceo-film-play').on('click', function () {
				var videoBtn = $(this);
				var video = $(this).closest('.ceo-media').find('video')[0];
				var video2 = $(this).closest('.ceo-media').find('video');

				if (video.paused) {
					videoBtn.fadeOut();
					video.play();
					video2.attr('controls', true);
				} else {
					video.pause();
					video2.attr('controls', false);
				}
			});

			$('.ceo-film').on('click', function () {
				var videoBtn = $('.ceo-film-play');
				var video = $(this).closest('.ceo-media').find('video')[0];
				var video2 = $(this).closest('.ceo-media').find('video');

				if (!video.paused) {
					video.pause();
					video2.attr('controls', false);
					videoBtn.fadeIn();
				}
			});

			const swiperBanner = new Swiper('.homepage .swiper-banner', {
				loop: false,
				spaceBetween: 0,
				autoplay: {
					delay: 8000,
				},
				navigation: {
					nextEl: '.swiper-banner .swiper-button-next',
					prevEl: '.swiper-banner .swiper-button-prev',
				},
			});

			const swiperTabor = new Swiper('.homepage .swiper-tabor', {
				loop: false,
				spaceBetween: 20,
				slidesPerView: 1,
				navigation: {
					nextEl: 'section.tabor .swiper-button-next',
					prevEl: 'section.tabor .swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				}
			});

			const postsSwiper = document.querySelectorAll('.swiper-posts');
			postsSwiper.forEach(function (slider) {
				new Swiper(slider, {
					loop: false,
					spaceBetween: 20,
					slidesPerView: 1,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
					}
				})
			});

		}
	});
}(jQuery));
